import fetch from '../../auth/FetchInterceptor';

export const getNotifications = function (perPage, page, unread = false) {
  return fetch({
    url: `/notifications?per_page=${perPage}&page=${page}${
      unread === true ? '&unread=1' : ''
    }`,
    method: 'get',
  });
};

export const getUnreadCount = function () {
  return fetch({
    url: `/notifications/total`,
    method: 'get',
  });
};

/**
 * Gets all the unread notifications.
 *
 * @param count the count of all unread notifications
 * @returns all unread notifications
 */
export const getUnreadNotifications = function (count) {
  return fetch({
    url: `/notifications/?unread=1&per_page=${count}`,
    method: 'get',
  });
};

export const getNotification = function (id) {
  return fetch({
    url: `/notifications/${id}`,
    method: 'get',
  });
};
